//libs
import { useContext } from 'react';

//components
import LocationFilters from '../../../location-filters';
import NewIekLocationFilters from './location-filters';
import Select from './select';

//types
import { StoresContext } from '../../../../App';

const features = {
    Special: 'Specialty store',
    DIY: 'DIY',
    WebStore: 'Online store',
    Wholesale: 'Wholesale',
    PanelAssembly: 'Electrical panel assembly',
};

const featureOptions = Object.entries(features).map(([code, name]) => ({
    name,
    value: { code, value: null },
}));

export default function LocationSelects() {
    const { featureFilters, setFeatureFilters } =
        useContext(StoresContext);
    const selectedFeature = features[featureFilters[0]?.code as keyof typeof features] || '';

    return (
        <div id="wereToBuyPartnerSelect" className="select-group select-group--vertical partners-select marketnavigator-filters">
            <LocationFilters render={NewIekLocationFilters} />
            <div className="select-item partners-select-item">
                <Select
                    name="Partner type"
                    value={selectedFeature}
                    options={featureOptions}
                    onChange={(val) => setFeatureFilters(val ? [val] : [])}
                />
            </div>
        </div>
    );
}